/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Logo_Carousel_LabelInputs */

const en_landing_logo_carousel_label = /** @type {(inputs: Landing_Logo_Carousel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your CV passes these ATS systems`)
};

const de_landing_logo_carousel_label = /** @type {(inputs: Landing_Logo_Carousel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihr Lebenslauf passiert diese ATS-Systeme`)
};

const fr_landing_logo_carousel_label = /** @type {(inputs: Landing_Logo_Carousel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre CV passe ces systèmes ATS`)
};

const es_landing_logo_carousel_label = /** @type {(inputs: Landing_Logo_Carousel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu CV pasa estos sistemas ATS`)
};

const it_landing_logo_carousel_label = /** @type {(inputs: Landing_Logo_Carousel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo CV passa questi sistemi ATS`)
};

const nl_landing_logo_carousel_label = /** @type {(inputs: Landing_Logo_Carousel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jouw CV passeert deze ATS-systemen`)
};

const pl_landing_logo_carousel_label = /** @type {(inputs: Landing_Logo_Carousel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoje CV przechodzi przez te systemy ATS`)
};

const fi_landing_logo_carousel_label = /** @type {(inputs: Landing_Logo_Carousel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV:si läpäisee nämä ATS-järjestelmät`)
};

const da_landing_logo_carousel_label = /** @type {(inputs: Landing_Logo_Carousel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit CV passerer disse ATS-systemer`)
};

const sv_landing_logo_carousel_label = /** @type {(inputs: Landing_Logo_Carousel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ditt CV passerar dessa ATS-system`)
};

/**
* | output |
* | --- |
* | "Your CV passes these ATS systems" |
*
* @param {Landing_Logo_Carousel_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_logo_carousel_label = /** @type {((inputs?: Landing_Logo_Carousel_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Logo_Carousel_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_logo_carousel_label(inputs)
	if (locale === "fr") return fr_landing_logo_carousel_label(inputs)
	if (locale === "es") return es_landing_logo_carousel_label(inputs)
	if (locale === "it") return it_landing_logo_carousel_label(inputs)
	if (locale === "nl") return nl_landing_logo_carousel_label(inputs)
	if (locale === "pl") return pl_landing_logo_carousel_label(inputs)
	if (locale === "fi") return fi_landing_logo_carousel_label(inputs)
	if (locale === "da") return da_landing_logo_carousel_label(inputs)
	if (locale === "sv") return sv_landing_logo_carousel_label(inputs)
	return en_landing_logo_carousel_label(inputs)
});